






































































import { Component, Vue, Provide, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "orderDeal",
  components: {},
})
export default class CombinationProperty extends Vue {
  @Prop() basicInfo: any;
  @Prop() imgsInfo: any;
  @Provide() private isBasicInfo: any = false;
  @Provide() private isImgsInfo: any = false;

  @Watch("basicInfo")
  onBasicInfoChanged(val: any) {
    this.isBasicInfo = val ? true : false;
  }
  @Watch("imgsInfo")
  onImgsInfoChanged(val: any) {
    this.isImgsInfo = val ? true : false;
  }

  private mounted() {}
}
